import { AddressHistoryEntryState, AddressHistoryEntryAction, AddressSubQuestion } from './AddressHistoryEntryContext'

const getNextQuestion = (
  currentQuestion: AddressSubQuestion
): AddressSubQuestion | undefined => {
  switch (currentQuestion) {
    case 'ADDRESS_DETAILS':
      return 'STATUS'
    case 'TIME_IN_SITUATION':
      return undefined
    case 'STATUS':
      return 'TIME_IN_SITUATION'
    default:
      return undefined
  }
}

const getPreviousQuestion = (
  currentQuestion: AddressSubQuestion
): AddressSubQuestion | undefined => {
  switch (currentQuestion) {
    case 'ADDRESS_DETAILS':
      return undefined
    case 'TIME_IN_SITUATION':
      return 'STATUS'
    case 'STATUS':
      return 'ADDRESS_DETAILS'
    default:
      return undefined
  }
}

const AddressHistoryEntryReducer = () => (
  previousState: AddressHistoryEntryState,
  action: AddressHistoryEntryAction
): AddressHistoryEntryState => {
  switch (action.type) {
    case 'NEXT': {
      const nextQuestion = getNextQuestion(previousState.question)
      if (nextQuestion === undefined) {
        return {
          ...previousState,
          escapeAction: 'NEXT'
        }
      }
      return {
        ...previousState,
        escapeAction: undefined,
        question: nextQuestion
      }
    }
    case 'PREVIOUS': {
      const previousQuestion = getPreviousQuestion(previousState.question)
      if (previousQuestion === undefined) {
        return {
          ...previousState,
          escapeAction: 'PREVIOUS'
        }
      }
      return {
        ...previousState,
        escapeAction: undefined,
        question: previousQuestion
      }
    }
    case 'UPDATE_ADDRESS_DETAILS':
      return {
        ...previousState,
        entry: {
          ...previousState.entry,
          addressDetails: action.value
        }
      }
    case 'UPDATE_STATUS':
      return {
        ...previousState,
        entry: {
          ...previousState.entry,
          addressSituation: action.value
        }
      }
    case 'UPDATE_TIME_IN_SITUATION':
      return {
        ...previousState,
        entry: {
          ...previousState.entry,
          lengthOfTime: action.value
        }
      }
    case 'UPDATE_DISPLAY_STATE':
      return {
        ...previousState,
        entry: {
          ...previousState.entry,
          displayState: action.value
        }
      }
    case 'UPDATE_LOQATE_RESULTS':
      return {
        ...previousState,
        entry: {
          ...previousState.entry,
          loqateResults: action.value
        }
      }
    case 'UPDATE_POSTCODE_SEARCH_LABEL':
      return {
        ...previousState,
        entry: {
          ...previousState.entry,
          addressLabel: action.value
        }
      }
    case 'UPDATE_POSTCODE_SEARCH_ATTEMPTED':
      return {
        ...previousState,
        entry: {
          ...previousState.entry,
          postcodeSearchAttempted: action.value
        }
      }
    default:
      return previousState
  }
}

export default AddressHistoryEntryReducer
